// extracted by mini-css-extract-plugin
export default {"container":"Replay_container__jQuoW","tableContainer":"Replay_tableContainer__edP1O"};